import { StatusIndicatorProps } from './StatusIndicator.model';
import css from './StatusIndicator.module.scss';

export const StatusIndicator = ({ size, color }: StatusIndicatorProps) => (
  <div
    className={`${css.circle} ${css[color.toLowerCase()]}`}
    style={{ width: `${size}px` }}
  />
);
